/**
 * Popover.Disclosure theme values.
 */
import { Components } from "@oui/system/components"
import { css } from "@oui/system"

const appearances: Components["Popover"]["Disclosure"]["appearances"] = {
  default: css``
}

export default { appearances }
